export { default } from './BrandEquity.js'
